import { useMemo } from 'react';
import { MaskedInput } from '../ui/MaskedInput';
import { maskMoney, parseMoney } from '../../utils/masks';
import { rubleAmountToWords } from '../../utils/numberToWords';

interface Props {
  label: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  showWords?: boolean;
}

export function MoneyField({ label, value, onChange, required, showWords = true }: Props) {
  const words = useMemo(() => {
    const n = parseMoney(value);
    if (!n) return '';
    return rubleAmountToWords(n);
  }, [value]);

  return (
    <div>
      <MaskedInput
        label={`${label}${required ? ' *' : ''}`}
        inputMode="decimal"
        value={value}
        mask={maskMoney}
        onValueChange={onChange}
        placeholder="0,00"
      />
      {showWords && words && (
        <p className="text-xs text-slate-600 mt-1 italic">{words}</p>
      )}
    </div>
  );
}
